export const MODULE_RECOVERY_WINDOW_MS = 60_000;

export function shouldReloadModuleFailure(error: unknown, lastReload: number | null, now: number): boolean {
  if (!(error instanceof Error)) return false;
  const moduleFailure = /Failed to fetch dynamically imported module|Importing a module script failed|Loading chunk .* failed/i.test(error.message);
  return moduleFailure && (lastReload === null || now - lastReload >= MODULE_RECOVERY_WINDOW_MS);
}